import "./pages.css";

export const Home = () => {
    return(
        <h1 className="content">
            HOME - PUBLIC
        </h1>
    );
}